<div class="obg-m-multi-deposit-limit">
	<mat-card>
		<form class="obg-m-multi-deposit-limit-form" [formGroup]="multiDepositLimitFormGroup">
			<obg-m-deposit-limit-item
				[control]="multiDepositLimitFormGroup?.controls.dailyDepositLimit"
				suffix="daily"
				[autoFocus]="autoFocusFirstField"
				[hideValidator]="forceInvalidForm"
				[showInputField]="!hasCurrentLimits || showInputFields"
				[placeholder]="placeholder"
				[currencySymbol]="currencySymbol"
				[prefixCurrencySymbol]="prefixCurrencySymbol"
				[currentLimitValue]="currentDepositLimits?.dailyDepositLimit"
				[hideInputHint]="hideInputHint"
			>
			</obg-m-deposit-limit-item>

			<obg-m-deposit-limit-item
				[control]="multiDepositLimitFormGroup?.controls.weeklyDepositLimit"
				suffix="weekly"
				[hideValidator]="forceInvalidForm"
				[showInputField]="!hasCurrentLimits || showInputFields"
				[placeholder]="placeholder"
				[currencySymbol]="currencySymbol"
				[prefixCurrencySymbol]="prefixCurrencySymbol"
				[currentLimitValue]="currentDepositLimits?.weeklyDepositLimit"
				[limitSuggestion]="weeklySuggestion"
				[hideInputHint]="hideInputHint"
			>
			</obg-m-deposit-limit-item>

			<obg-m-deposit-limit-item
				[control]="multiDepositLimitFormGroup?.controls.monthlyDepositLimit"
				suffix="monthly"
				[hideValidator]="forceInvalidForm"
				[showInputField]="!hasCurrentLimits || showInputFields"
				[placeholder]="placeholder"
				[currencySymbol]="currencySymbol"
				[prefixCurrencySymbol]="prefixCurrencySymbol"
				[currentLimitValue]="currentDepositLimits?.monthlyDepositLimit"
				[limitSuggestion]="monthlySuggestion"
				[hideInputHint]="hideInputHint"
			>
			</obg-m-deposit-limit-item>
		</form>

		<div *ngIf="upcomingDepositLimits" class="obg-m-multi-deposit-limit-form-upcoming">
			<label
				class="obg-m-multi-deposit-limit-upcoming-limit"
				test-id="daily-deposit-limit"
				data-test-id="daily-deposit-limit"
				*ngIf="
					upcomingDepositLimits.dailyDepositLimit &&
					upcomingDepositLimits.dailyDepositLimit !== currentDepositLimits.dailyDepositLimit
				"
				[innerHtml]="
					'multi-deposit-limit.upcoming-limit.daily'
						| translate
							: {
									queuedAmount:
										upcomingDepositLimits.dailyDepositLimit
										| obgCurrency: undefined : undefined : '1.0-0',
									startDate: upcomingDepositLimits?.startDate | date: 'dd MMMM yyyy',
							  }
				"
			>
			</label>

			<label
				class="obg-m-multi-deposit-limit-upcoming-limit"
				test-id="weekly-deposit-limit"
				data-test-id="weekly-deposit-limit"
				*ngIf="
					upcomingDepositLimits.weeklyDepositLimit &&
					upcomingDepositLimits.weeklyDepositLimit !== currentDepositLimits.weeklyDepositLimit
				"
				[innerHtml]="
					'multi-deposit-limit.upcoming-limit.weekly'
						| translate
							: {
									queuedAmount:
										upcomingDepositLimits.weeklyDepositLimit
										| obgCurrency: undefined : undefined : '1.0-0',
									startDate: upcomingDepositLimits?.startDate | date: 'dd MMMM yyyy',
							  }
				"
			>
			</label>

			<label
				class="obg-m-multi-deposit-limit-upcoming-limit"
				test-id="monthly-deposit-limit"
				data-test-id="monthly-deposit-limit"
				*ngIf="
					upcomingDepositLimits.monthlyDepositLimit &&
					upcomingDepositLimits.monthlyDepositLimit !== currentDepositLimits.monthlyDepositLimit
				"
				[innerHtml]="
					'multi-deposit-limit.upcoming-limit.monthly'
						| translate
							: {
									queuedAmount:
										upcomingDepositLimits.monthlyDepositLimit
										| obgCurrency: undefined : undefined : '1.0-0',
									startDate: upcomingDepositLimits?.startDate | date: 'dd MMMM yyyy',
							  }
				"
			>
			</label>
		</div>

		<div class="obg-m-multi-deposit-limit-button-container">
			<button
				mat-flat-button
				*ngIf="showInputFields"
				(click)="toggleInputFields.emit(false)"
				test-id="deposit-limit-edit-cancel"
				data-test-id="deposit-limit-edit-cancel"
				class="obg-m-multi-deposit-limit-button-container-cancel"
			>
				{{ "general.cancel" | translate }}
			</button>

			<button
				class="obg-m-multi-deposit-limit-submit"
				mat-flat-button
				color="accent"
				*ngIf="!hasCurrentLimits || showInputFields; else changeLimitButton"
				[disabled]="!multiDepositLimitFormGroup.valid || setDepositLoading"
				(click)="formSubmitted.emit(redirectToDeposit)"
				test-id="multi-deposit-limit-submit-button"
				data-test-id="multi-deposit-limit-submit-button"
			>
				<mat-spinner *ngIf="setDepositLoading; else showContent" diameter="20"></mat-spinner>
				<ng-template #showContent>{{
					(redirectToDeposit
						? "multi-deposit-limit.set-limit-and-deposit"
						: sessionLimitUnset
							? "general.continue"
							: "multi-deposit-limit.set-limit"
					) | translate
				}}</ng-template>
			</button>

			<ng-template #changeLimitButton>
				<button
					mat-flat-button
					color="accent"
					test-id="change-deposit-limit"
					data-test-id="change-deposit-limit"
					(click)="toggleInputFields.emit(true)"
				>
					{{ "deposit-limit.change-deposit-limit" | translate }}
				</button>
			</ng-template>

			<label
				class="validation-error"
				*ngIf="showInputFields && forceInvalidForm && multiDepositLimitFormGroup?.touched"
				>{{ "multi-deposit-limit.same-" + validationKey + "-deposit-limit" | translate }}</label
			>
		</div>

		<div class="obg-m-multi-deposit-limit-banner-container">
			<obg-m-deposit-limit-calculator-banner
				*ngIf="!hideDepositLimitCalculatorBanner"
			></obg-m-deposit-limit-calculator-banner>
		</div>
	</mat-card>
</div>
